import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock, BookOpen, Award, CheckCircle2, Sparkles } from "lucide-react";
import { Button } from "./ui/button";
import { COURSE } from "../data/mock";
import { PROMO } from "../data/promo";

export default function CourseHighlight() {
  return (
    <section id="corso" className="relative py-24 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="reveal rounded-3xl bg-gradient-to-br from-[#0a1f55] via-[#102a6b] to-[#1e3a8a] p-8 md:p-12 lg:p-14 text-white relative overflow-hidden">
          <div className="absolute -top-24 -right-24 h-80 w-80 rounded-full bg-[#f59e0b]/20 blur-3xl"></div>
          <div className="absolute -bottom-24 -left-24 h-80 w-80 rounded-full bg-white/10 blur-3xl"></div>

          <div className="relative grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <div className="text-xs font-bold tracking-[0.22em] uppercase text-[#f59e0b]">
                Corso A.C.D.T. per la qualificazione professionale — Certificato L. 4/2013
              </div>
              <h2 className="mt-3 text-3xl md:text-5xl font-extrabold leading-[1.05]">
                {COURSE.title}
              </h2>
              <p className="mt-4 text-slate-200/90 max-w-2xl leading-relaxed">
                {COURSE.description}
              </p>

              <div className="mt-7 grid sm:grid-cols-3 gap-3">
                <Pill icon={Clock} label="20 ore" />
                <Pill icon={BookOpen} label="20 moduli" />
                <Pill icon={Award} label="Attestato + Tessera" />
              </div>

              <ul className="mt-7 grid sm:grid-cols-2 gap-x-6 gap-y-2">
                {COURSE.includes.slice(0, 6).map((it) => (
                  <li key={it} className="flex items-start gap-2 text-[14px] text-slate-200">
                    <CheckCircle2 className="h-4 w-4 mt-0.5 text-[#fbbf24]" />
                    <span>{it}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-8 flex flex-wrap items-center gap-3">
                <Link to="/corso">
                  <Button className="bg-[#f59e0b] hover:bg-[#d97706] text-[#0a1f55] font-bold h-12 px-6">
                    Scopri il corso
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </Link>
                <Link to="/corso#acquista">
                  <Button variant="outline" className="h-12 bg-white/5 border-white/20 text-white hover:bg-white/10 hover:text-white" data-testid="ch-acquista-btn">
                    {PROMO.active ? (
                      <>Acquista ora • <span className="line-through opacity-70 mr-1">€ {PROMO.prezzoListinoCorso}</span> € {PROMO.prezzoPromoCorso}</>
                    ) : (
                      <>Acquista ora • da € 99</>
                    )}
                  </Button>
                </Link>
              </div>

              {/* Membership required notice */}
              <div className="mt-6 inline-flex items-start gap-3 rounded-xl bg-[#f59e0b]/15 border border-[#f59e0b]/30 px-4 py-3 max-w-2xl">
                <div className="h-7 w-7 rounded-full bg-[#f59e0b] text-[#0a1f55] flex items-center justify-center text-[12px] font-extrabold shrink-0">!</div>
                <p className="text-[13px] text-slate-100 leading-relaxed">
                  <strong className="text-[#fbbf24]">Importante:</strong> per iscriversi ai corsi è necessario essere
                  <strong className="text-white"> tesserati A.C.D.T.</strong> La tessera è inclusa nei pacchetti
                  &laquo;Corso + Tessera&raquo; e &laquo;Premium&raquo;.
                </p>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="rounded-2xl overflow-hidden border border-white/10 bg-white/5 backdrop-blur-sm">
                <div className="aspect-[4/3] relative bg-[#0a1f55]">
                  <img
                    src={COURSE.hero}
                    alt={COURSE.title}
                    className="absolute inset-0 h-full w-full object-cover"
                    onError={(e) => { e.currentTarget.style.display = "none"; }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0a1f55]/50 to-transparent"></div>
                </div>
                <div className="p-5 flex items-center justify-between">
                  <div>
                    <div className="text-[11px] uppercase tracking-wider text-slate-300">Da</div>
                    <div className="flex items-baseline gap-2">
                      {PROMO.active && (
                        <span className="text-xl font-bold text-slate-400 line-through">€ {PROMO.prezzoListinoCorso}</span>
                      )}
                      <div className="text-3xl font-extrabold text-white">€ {PROMO.active ? PROMO.prezzoPromoCorso : "99"},00</div>
                    </div>
                    {PROMO.active && (
                      <div className="text-[11px] text-[#fbbf24] font-bold mt-1 uppercase tracking-wider">{PROMO.labelOfferta}</div>
                    )}
                  </div>
                  <div className={`px-3 py-1.5 rounded-lg text-[11px] font-extrabold uppercase tracking-wider ${PROMO.active ? "bg-red-600 text-white" : "bg-[#f59e0b] text-[#0a1f55]"}`}>
                    {PROMO.active ? `-${PROMO.scontoEuro}€` : "Posti limitati"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Pill({ icon: Icon, label }) {
  return (
    <div className="flex items-center gap-2 rounded-xl bg-white/[0.06] border border-white/10 px-4 py-3">
      <Icon className="h-4 w-4 text-[#f59e0b]" />
      <span className="text-[13px] font-semibold text-white">{label}</span>
    </div>
  );
}
